import { createValidator, validationRules } from "../../utils/validation";
import { getClientTypeOptions } from "../../components/options/options";
import { sharedData } from "../../sharedData/sharedData";
import { 
    clientCounterPartySchema, 
    overSeasEntitiesYesSchema, 
    isRegulatoryListedYesSchema, 
    isBillingRecognizedYesSchema, 
    complyWithRegulationsSchema
 } from "../validationRules/validateClientCounterpartyForm";

export const useValidateClientCounterParty = () => {
    const validateClientCounterParty = (formData) => {
        let customValidator = {...clientCounterPartySchema};

        // A stored involvement that is not on the current deal's option list (e.g. a
        // quick-filled "Landlord" on a Sale) renders as nothing selected. Checking it
        // against the same list the radio group uses stops that passing as "filled in".
        const allowedClientTypes = getClientTypeOptions(
            sharedData.get("transactionType"),
            sharedData.get("transactionId")
        ).map((option) => option.value);

        customValidator = {
            ...customValidator,
            clientType: [
                ...clientCounterPartySchema.clientType,
                validationRules.oneOf(
                    allowedClientTypes,
                    "What involvement does the entity have in the transaction? is required"
                ),
            ],
        };

        if (formData.overseasEntities === "Yes") {
            customValidator = { ...customValidator, ...overSeasEntitiesYesSchema };
        }

        if (formData.isRegulatoryListed === "Yes") {
            customValidator = { ...customValidator, ...isRegulatoryListedYesSchema };
        }

        if (formData.isBillingRecognized === "Yes") {
            customValidator = { ...customValidator, ...isBillingRecognizedYesSchema };
        }

        if (formData.complyWithRegulations === "Yes") {
            customValidator = { ...customValidator, ...complyWithRegulationsSchema };
        }
        const validator = createValidator(customValidator);
        return validator(formData);
    }

    return { validateClientCounterParty };
}